export const PALETTE_IDS = {
    //-- Tiles
    SKELETON: 'tile.SKELETON_PART',
    INPUT: 'tile.INPUT',
    STAKE_INPUT: 'tile.STAKE_INPUT',
    DOT_NOTIFICATION: 'tile.DOT_NOTIFICATION',
    STREAMING_INDICATOR: 'tile.STREAMING_INDICATOR',
    POPOVER: 'tile.POPOVER',
    ODDS_BUTTON: 'tile.ODDS_BUTTON',
    PRICE_CHANGE_INDICATOR: 'tile.PRICE_CHANGE_INDICATOR',
    CHANGED_VALUE_INDICATOR: 'tile.CHANGED_VALUE_INDICATOR',
    ERROR_NOTIFICATION: 'tile.NOTIFICATION.ERROR',
    WARNING_NOTIFICATION: 'tile.NOTIFICATION.WARNING',
    SUCCESS_NOTIFICATION: 'tile.NOTIFICATION.SUCCESS',
    INFO_NOTIFICATION: 'tile.NOTIFICATION.INFO',
    BET_NOTIFICATIONS: 'tile.BET_NOTIFICATIONS',
    RANGE_INPUT: 'tile.RANGE_INPUT',
    PRIMARY_LINK: 'tile.LINK.PRIMARY',
    SECONDARY_LINK: 'tile.LINK.SECONDARY',
    TERTIARY_LINK: 'tile.LINK.TERTIARY',
    SWITCH: 'tile.SWITCH',
    EMPTY_CONTENT_MESSAGE: 'tile.EMPTY_CONTENT_MESSAGE',
    PRIMARY_DROPDOWN: 'tile.DROPDOWN.PRIMARY',
    SECONDARY_DROPDOWN: 'tile.DROPDOWN.SECONDARY',
    TERTIARY_DROPDOWN: 'tile.DROPDOWN.TERTIARY',
    DROPDOWN_MENU: 'tile.DROPDOWN.MENU',
    TOGGLE_BUTTON: 'tile.BUTTON.TOGGLE',
    PRIMARY_BUTTON: 'tile.BUTTON.PRIMARY',
    SECONDARY_BUTTON: 'tile.BUTTON.SECONDARY',
    TERTIARY_BUTTON: 'tile.BUTTON.TERTIARY',
    CHECKBOX: 'tile.CHECKBOX',
    PIVOT: 'tile.PIVOT',
    CLOSE_BUTTON: 'tile.CLOSE_BUTTON',
    LIST_ITEM: 'tile.LIST_ITEM',
    EVENT_TIMING_STATUS: 'tile.EVENT_TIMING_STATUS',
    EVENT_CARD_DETAILS: 'tile.EVENT_CARD_DETAILS',
    BANNER_CARD_DETAILS: 'tile.BANNER_CARD_DETAILS',
    AVANTGARDE_BANNER_CARD_DETAILS: 'tile.AVANTGARDE_BANNER_CARD_DETAILS',
    PREBUILT_CARD_DETAILS: 'tile.PREBUILT_CARD_DETAILS',
    MINI_SCOREBOARD: 'tile.MINI_SCOREBOARD',
    RUNNER_INFO: 'tile.RUNNER_INFO',
    PARTICIPANTS: 'tile.PARTICIPANTS',
    TABLE: 'tile.TABLE',
    MINI_EVENT_ITEM_CONTENT: 'tile.MINI_EVENT_ITEM_CONTENT',
    MINI_EVENT_ITEM: 'tile.MINI_EVENT_ITEM',
    EVENTS_COUPON: 'tile.EVENTS_COUPON',
    EVENT_LIST: 'tile.EVENT_LIST',
    EVENT_DETAILS: 'tile.EVENT_DETAILS',
    EVENT_LIST_HEADER: 'tile.EVENT_LIST_HEADER',
    PROMOTION_QUICK_LINKS: 'tile.PROMOTION_QUICK_LINKS',
    BET_BUILDER_SELECTION_ITEM: 'tile.BET_BUILDER_SELECTION_ITEM',
    BET_STATUS_ICON: 'tile.BET_STATUS_ICON',
    BET_FUNDS_INFO: 'tile.BET_FUNDS_INFO',
    BET_BASE_INFO: 'tile.BET_BASE_INFO',
    BET_LEGS_INFO: 'tile.BET_LEGS_INFO',
    BONUS_INDICATOR: 'tile.BONUS_INDICATOR',
    EARLY_PAYOUT_INDICATOR: 'tile.EARLY_PAYOUT_INDICATOR',
    PROGRESS_BAR: 'tile.PROGRESS_BAR',
    BET_RECEIPT: 'tile.BET_RECEIPT',
    SETTINGS: 'tile.SETTINGS',
    PRICE_BOOST_LABEL: 'tile.PRICE_BOOST_LABEL',
    PRICE_BOOST_ITEM: 'tile.PRICE_BOOST_ITEM',
    PRICE_BOOST_BANNER: 'tile.PRICE_BOOST_BANNER',
    SEARCH_RESULT: 'tile.SEARCH_RESULT',
    ODDS_BOOST_BANNER: 'tile.ODDS_BOOST_BANNER',
    NEUTRAL_VENUE_INDICATOR: 'tile.NEUTRAL_VENUE_INDICATOR',
    VIEW_SWITCHER: 'tile.VIEW_SWITCHER',
    YOUR_BET: 'tile.YOUR_BET',
    SCOREBOARD: 'tile.SCOREBOARD',
    FAVORITE_ICON: 'tile.FAVORITE_ICON',
    CONTROL_BUTTON: 'tile.CONTROL_BUTTON',
    MARKETS_GROUPS_SELECTOR: 'tile.MARKETS_GROUPS_SELECTOR',
    //-- Lotto tiles
    LOTTO_BALL_NUMBER: 'tile.LOTTO_BALL_NUMBER',
    LOTTO_DRAW_LIST: 'tile.LOTTO_DRAW_LIST',
    LOTTO_DRAW_LIST_ITEM: 'tile.LOTTO_DRAW_LIST_ITEM',
    LOTTO_DRAW_SELECTOR: 'tile.LOTTO_DRAW_SELECTOR',
    //-- Retail tiles
    RETAIL_SAVED_BET_DETAILS: 'tile.RETAIL_SAVED_BET_DETAILS',
    //-- Palettes
    BASE: 'appearance.BASE_PALETTE',
    MOBILE_NAVBAR: 'appearance.MOBILE_NAVBAR',
    SEARCH: 'appearance.SEARCH',
    DISCOVERY_SEARCH: 'appearance.DISCOVERY_SEARCH',
    VIRTUALS: 'appearance.VIRTUALS',
    VISUALISATION: 'appearance.VISUALISATION',
    CUSTOM_PAGE: 'appearance.CUSTOM_PAGE',
    EVENT_DISCLAIMER: 'appearance.EVENT_DISCLAIMER',
    SPORTS_CONTENT: 'appearance.SPORTS_CONTENT',
    HOME_PAGE_CLASSIC: 'appearance.HOME_PAGE_CLASSIC',
    HOME_PAGE_AVANTGARDE: 'appearance.HOME_PAGE_AVANTGARDE',
    SPORT_PAGE: 'appearance.SPORT_PAGE',
    INPLAY_PAGE: 'appearance.INPLAY_PAGE',
    NUMERIC_KEYPAD: 'appearance.NUMERIC_KEYPAD',
    RACE_CARD: 'appearance.RACE_CARD',
    MENUS_LINKS_LISTS: 'appearance.MENUS_LINKS_LISTS',
    AZ_MENU: 'appearance.AZ_MENU',
    QUICK_NAVIGATIONS: 'appearance.QUICK_NAVIGATIONS',
    DESKTOP_INFO_SECTION: 'appearance.DESKTOP_INFO_SECTION',
    DESKTOP_CMS_LINKS: 'appearance.DESKTOP_CMS_LINKS',
    DIALOGS: 'appearance.DIALOGS',
    AUTO_CASHOUT_DIALOG: 'appearance.AUTO_CASHOUT_DIALOG',
    ACCEPT_DIALOG: 'appearance.ACCEPT_DIALOG',
    PROMO_MESSAGE_DIALOG: 'appearance.PROMO_MESSAGE_DIALOG',
    LOGIN_DIALOG: 'appearance.LOGIN_DIALOG',
    ODDS_BOOSTS_DIALOG: 'appearance.ODDS_BOOSTS_DIALOG',
    TOAST: 'appearance.TOAST',
    ALERT_DIALOG: 'appearance.ALERT_DIALOG',
    QUICK_START_GUIDE: 'appearance.QUICK_START_GUIDE',
    COMBINATION_ODDS_POPUP: 'appearance.COMBINATION_ODDS_POPUP',
    BET_SHARING_DIALOG: 'appearance.BET_SHARING_DIALOG',
    FUTURE_RACING: 'appearance.FUTURE_RACING',
    RACE_MEETINGS: 'appearance.RACE_MEETINGS',
    RACING: 'appearance.RACING',
    COUPONS: 'appearance.COUPONS',
    EVENT_PAGE: 'appearance.EVENT_PAGE',
    MARKETS: 'appearance.MARKETS',
    EVENT_TIPS: 'appearance.EVENT_TIPS',
    VIDEO_STREAMING: 'appearance.VIDEO_STREAMING',
    BET_HISTORY: 'appearance.BET_HISTORY',
    YOUR_BETS: 'appearance.YOUR_BETS',
    MY_ACCOUNT_DIALOG: 'appearance.MY_ACCOUNT_DIALOG',
    ACCOUNT_POPOVER: 'appearance.ACCOUNT_POPOVER',
    MY_ACCOUNT_PAGE: 'appearance.MY_ACCOUNT_PAGE',
    STATIC_PAGES: 'appearance.STATIC_PAGES',
    BAD_ROUTE_PAGE: 'appearance.BAD_ROUTE_PAGE',
    MAINTENANCE: 'appearance.MAINTENANCE',
    NATIVE_HOSTING_PAGE: 'appearance.NATIVE_HOSTING_PAGE',
    FOREIGN_WINDOW: 'appearance.FOREIGN_WINDOW',
    APP_VIEW: 'appearance.APPLICATION_VIEW',
    BETTING_CENTER: 'appearance.BETTING_CENTER',
    BETSLIP: 'appearance.BETSLIP',
    OVERASK: 'appearance.OVERASK',
    QUICK_BETSLIP: 'appearance.QUICK_BETSLIP',
    NATIVE_APP: 'appearance.NATIVE_APP',
    CARDS_AND_PROMOTIONS: 'appearance.CARDS_AND_PROMOTIONS',
    PROMOTIONS: 'appearance.PROMOTIONS',
    BANNER_CARDS: 'appearance.BANNER_CARDS',
    PRE_BUILT_CARDS: 'appearance.PRE_BUILT_CARDS',
    EVENT_CARDS: 'appearance.EVENT_CARDS',
    PROP_CARDS: 'appearance.PROP_CARDS',
    AVANTGARDE: 'appearance.AVANTGARDE',
    AVANTGARDE_MAIN_NAVIGATION_BAR: 'appearance.AVANTGARDE_MAIN_NAVIGATION_BAR',
    AVANTGARDE_CARDS: 'appearance.AVANTGARDE_CARDS',
    AVANTGARDE_BANNER_CARDS: 'appearance.AVANTGARDE_BANNER_CARDS',
    AVANTGARDE_EVENT_CARDS: 'appearance.AVANTGARDE_EVENT_CARDS',
    AVANTGARDE_PRE_BUILT_CARDS: 'appearance.AVANTGARDE_PRE_BUILT_CARDS',
    AVANTGARDE_VERTICAL_MATCH_CARDS: 'appearance.AVANTGARDE_VERTICAL_MATCH_CARDS',
    INTERFACE: 'appearance.INTERFACE',
    BREADCRUMBS: 'appearance.BREADCRUMBS',
    APP_BANNER: 'APP_BANNER',
    APPLICATION_HEADER: 'appearance.APPLICATION_HEADER',
    MAIN_NAVIGATION_BAR: 'appearance.MAIN_NAVIGATION_BAR',
    MATCH_ACCA: 'appearance.MATCH_ACCA',
    MARKET_INSTRUCTIONS: 'appearance.MARKET_INSTRUCTIONS',
    MATCH_ACCA_SLIP: 'appearance.MATCH_ACCA_SLIP',
    BONUSES: 'appearance.BONUSES',
    ACCOUNT: 'appearance.ACCOUNT',
    STATSCORE: 'appearance.STATSCORE',
    TABLE_LEAGUE_PAGE: 'appearance.TABLE_LEAGUE_PAGE',
    COMPETITIONS_KNOCKOUT_GRID: 'appearance.COMPETITIONS_KNOCKOUT_GRID',
    COMPETITIONS_TABLE: 'appearance.COMPETITIONS_TABLE',
    //-- Lotto Palettes
    LOTTO: 'appearance.LOTTO',
    LOTTERIES: 'appearance.LOTTERIES',
    LOTTERY_ITEM: 'appearance.LOTTERY_ITEM',
    BALL_DRAW: 'appearance.BALL_DRAW',
    LOTTERY_ODDS: 'appearance.LOTTERY_ODDS',
    LOTTO_BET_HISTORY: 'appearance.LOTTO_BET_HISTORY',
    LOTTO_BETSLIP: 'appearance.LOTTO_BETSLIP',
    LOTTO_BET_RECEIPT: 'appearance.LOTTO_BET_RECEIPT',
    LOTTO_HEADER: 'appearance.LOTTO_HEADER',
    //-- Retail Palettes
    RETAIL_BETS_INFO: 'appearance.RETAIL_BETS_INFO',
};
